// import { default as BtnAdd } from "./BtnAdd.vue";
import { default as BtnCancel } from "./BtnCancel.vue";
import { default as BtnDelete } from "./BtnDelete.vue";
import { default as BtnGenerate } from "./BtnGenerate.vue";
import { default as BtnRandom } from "./BtnRandom.vue";
import { default as BtnRemove } from "./BtnRemove.vue";
import { default as BtnReset } from "./BtnReset.vue";
import { default as BtnSubmit } from "./BtnSubmit.vue";
// import { default as BtnTrash } from "./BtnTrash.vue";
import { default as BtnUpdate } from "./BtnUpdate.vue";
import { default as ExtMarker } from "./ExtMarker.vue";
import { default as ExtRemove } from "./ExtRemove.vue";
import { default as ExtReset } from "./ExtReset.vue";
import { default as ExtUpdate } from "./ExtUpdate.vue";

export const Buttons = {
    // BtnAdd: BtnAdd,
    BtnCancel: BtnCancel,
    BtnDelete: BtnDelete,
    BtnGenerate: BtnGenerate,
    BtnRandom: BtnRandom,
    BtnRemove: BtnRemove,
    BtnReset: BtnReset,
    BtnSubmit: BtnSubmit,
    // BtnTrash: BtnTrash,
    BtnUpdate: BtnUpdate,
    ExtMarker: ExtMarker,
    ExtRemove: ExtRemove,
    ExtReset: ExtReset,
    ExtUpdate: ExtUpdate,
};
